import { trpc } from "../trpc";

type UseMeQueryOptions = {
  refetchInterval?: number | false | (() => number | false);
};

export function useMeQuery(options?: UseMeQueryOptions) {
  const meQuery = trpc.viewer.me.useQuery(undefined, {
    retry(failureCount) {
      return failureCount > 3;
    },
    ...options,
  });

  return meQuery;
}

export default useMeQuery;
